import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { blogArticles } from '../data/blogArticles';
import { BlogArticle1 } from './BlogArticle1';
import { BlogArticle2 } from './BlogArticle2';
import { BlogArticle3 } from './BlogArticle3';
import { BlogArticle4 } from './BlogArticle4';
import { BlogArticle5 } from './BlogArticle5';
import { BlogArticle6 } from './BlogArticle6';
import { BlogArticle7 } from './BlogArticle7';
import { BlogArticle8 } from './BlogArticle8';
import { BlogArticle9 } from './BlogArticle9';
import { BlogArticle10 } from './BlogArticle10';
export function BlogArticleDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const article = blogArticles.find(a => a.slug === slug);
  if (!article) {
    return <Navigate to="/blog" replace data-id="element-2086" />;
  }
  // Route to the appropriate article component based on slug
  switch (slug) {
    case 'what-do-you-whisper-to-the-machine':
      return <BlogArticle10 data-id="element-2087" />;
    case 'january-2026-changed-rules-enterprise-ai':
      return <BlogArticle9 data-id="element-2088" />;
    case 'time-saved-wrong-metric-ai-roi':
      return <BlogArticle8 data-id="element-2089" />;
    case 'new-article-template':
      return <BlogArticle7 data-id="element-2090" />;
    case 'access-not-intelligence':
      return <BlogArticle1 data-id="element-2091" />;
    case 'generic-to-genetic-corporate-genome':
      return <BlogArticle2 data-id="element-2092" />;
    case 'instruction-layer-missing-infrastructure':
      return <BlogArticle3 data-id="element-2093" />;
    case 'guardrails-that-work-framework':
      return <BlogArticle4 data-id="element-2094" />;
    case 'model-independence-context-outlives-llm':
      return <BlogArticle5 data-id="element-2095" />;
    case 'tacit-knowledge-not-capturing':
      return <BlogArticle6 data-id="element-2096" />;
    default:
      return <Navigate to="/blog" replace data-id="element-2097" />;
  }
}